/**
 * @generated SignedSource<<f48f782f9c911bcc733df803c321c344>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageTitle_SearchTitleFragment$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "getCachedPageTitle_SearchTitleFragment";
};
export type getCachedPageTitle_SearchTitleFragment$key = {
  readonly " $data"?: getCachedPageTitle_SearchTitleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageTitle_SearchTitleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageTitle_SearchTitleFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    }
  ],
  "type": "SearchConfluencePageBlogAttachment"
};

(node as any).hash = "d90150d434d564e9cfbe7d4d09a5bba7";

export default node;
